import { SegmentSchema } from '@sondermind/segment';

export enum HostAuthSegmentEvents {
  PROVIDER_403_ERROR = 'Provider 403 Error'
}

export interface IProvider403ErrorData {
  url: string;
  method: string;
  retry: boolean;
}

export interface IHostAuthSegmentSchema extends SegmentSchema {
  [HostAuthSegmentEvents.PROVIDER_403_ERROR]: IProvider403ErrorData;
}
